import { configureStore } from '@reduxjs/toolkit'
import AppReducer from '../reducer/app';
import PlanReducer from '../reducer/plan';
import UserReducer from "../reducer/user";


export default configureStore({
    reducer: {
        app: AppReducer,
        plan: PlanReducer,
        user: UserReducer,

    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
    })
})